// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");

function empty(param) {
  return {
          id: undefined,
          senderId: 0
        };
}

function make(senderId) {
  return senderId;
}

function setSenderId(senderId, t) {
  return {
          id: t.id,
          senderId: senderId
        };
}

function senderId(t) {
  return t.senderId;
}

function validSenderId(x) {
  return x !== 0;
}

function toForm(t) {
  return {
          id: {
            TAG: "Valid",
            _0: t.id
          },
          senderId: t.senderId !== 0 ? ({
                TAG: "Valid",
                _0: t.senderId
              }) : ({
                TAG: "Invalid",
                _0: t.senderId,
                _1: {
                  hd: "Sender Id Can't be Empty",
                  tl: /* [] */0
                }
              })
        };
}

function fromForm(form) {
  return {
          id: FormField$ReactHooksTemplate.getInputValue(form.id),
          senderId: FormField$ReactHooksTemplate.getInputValue(form.senderId)
        };
}

function encoder(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "sender_id",
                  t.senderId
                ],
                tl: /* [] */0
              }
            });
}

function decoder(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          senderId: Json_decode.field("sender_id", Json_decode.$$int, json)
        };
}

var modeType = "Sms";

exports.modeType = modeType;
exports.empty = empty;
exports.make = make;
exports.setSenderId = setSenderId;
exports.senderId = senderId;
exports.validSenderId = validSenderId;
exports.toForm = toForm;
exports.fromForm = fromForm;
exports.encoder = encoder;
exports.decoder = decoder;
/* No side effect */
